export function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const cookieValue = parts.pop()?.split(';').shift();
        return cookieValue ? decodeURIComponent(cookieValue) : null;
    }
    return null;
}

export function getEcidCookie(): string {
    return getCookie('AMCV_EF531F4866D1B25B0A495F96%40AdobeOrg') || '';
}